import React from "react";
import NavAndHero from "../components/NavAndHero";
import CallToAction from "../components/CTA";
import Footer from "../components/Footer";
import { ReactComponent as LeadGenImage } from "../images/undraw_connecting-teams_nnjy.svg"; // replace with your preferred SVG

const LeadServicePage = () => {
  return (
    <div data-theme="light">
      <NavAndHero />

      {/* Intro Section */}
      <section className="bg-blue-500 rounded-b-3xl py-20 px-4 text-center">
        <div className="max-w-3xl mx-auto space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            Online Marketing Service
          </h1>
          <p className="text-lg text-gray-100">
            Capture attention, drive traffic, and turn leads into loyal customers. Our tailored strategies help your business grow through optimized campaigns and creative marketing.
          </p>
        </div>
      </section>

      {/* Details Section */}
      <section className="py-20 px-4 bg-base-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-7xl mx-auto items-center">
          {/* Text */}
          <div className="space-y-4">
            <h2 className="text-4xl font-bold text-blue-500">What We Deliver</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Google & Facebook Ads (PPC Campaigns)</li>
              <li>Social Media Management</li>
              <li>Photo & Video Advert Creation</li>
              <li>Email Marketing Funnels</li>
              <li>SEO Optimization & Content Planning</li>
              <li>Landing Pages for Lead Capture</li>
            </ul>
          </div>

          {/* Image */}
          <div className="flex justify-center">
            <LeadGenImage className="w-full max-w-md h-auto" />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="bg-blue-100 py-20 px-4">
        <div className="max-w-6xl mx-auto text-center space-y-10">
          <h2 className="text-3xl font-bold text-blue-500">Why Work With Digiscape?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-left">
            <div>
              <h3 className="text-xl font-semibold">📊 Results-Driven Ads</h3>
              <p className="text-gray-700">
                Every campaign is optimized for real ROI — not just impressions.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold">👤 Social That Converts</h3>
              <p className="text-gray-700">
                Strategic content and engagement that brings in traffic and leads.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold">🔍 Full Funnel Strategy</h3>
              <p className="text-gray-700">
                We create experiences that take your customers from click to client.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div id="cta">
        <CallToAction />
      </div>
      <Footer />
    </div>
  );
};

export default LeadServicePage;
